//@ts-nocheck
/* eslint-disable */
import { htmlParse } from "../lib/utils";

export const Local = _DefaultLanguage || 'fa';
let enTranslationMessages = (await import(`./en.json`))?.default;
let faTranslationMessages = (await import(`./fa.json`))?.default;

const DEFAULT_LOCALE = Local;
const _AppList = ['business', 'contact','content','exam','home','place','registry','shop','ticket','users'];
for (const i in _AppList) {
  const app = _AppList[i];
  try {
    const en = await import(`./${app}/en.json`);
    // enTranslationMessages = Object.assign({}, enTranslationMessages?.default, en?.default);
    enTranslationMessages = {  ...enTranslationMessages, ...en?.default};

  } catch (e) {}
  try {
    const fa = await import(`./${app}/fa.json`);
    // faTranslationMessages = Object.assign({}, faTranslationMessages?.default, fa?.default);
    faTranslationMessages = {... faTranslationMessages, ...fa?.default};
  } catch (e) {}
}
// prettier-ignore
const appLocales = [
  'en',
  'fa',
];

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, faTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages("en", enTranslationMessages),
  fa: formatTranslationMessages("fa", faTranslationMessages),
};

// exports.appLocales = appLocales;
// exports.formatTranslationMessages = formatTranslationMessages;
// exports.translationMessages = translationMessages;
// exports.DEFAULT_LOCALE = DEFAULT_LOCALE;

export { appLocales };
export { formatTranslationMessages };
export { translationMessages };
export { DEFAULT_LOCALE };

type ParamsType = {
  app?: string;
  text: string;
  defaultText?: string;
  values?: object;
};
export function Trn(params: ParamsType) {
  const { app = "app", defaultText, values } = params;
  let text = params.text;
  const id = `${app}.${text}`;
  if (!values) {
    const defaultMessage = defaultText;
    if (translationMessages[Local][id]) {
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(translationMessages[Local][id]);
      return hasHtml
        ? htmlParse(translationMessages[Local][id])
        : translationMessages[Local][id];
    } else if (defaultMessage) {
      return defaultMessage;
    } else if (translationMessages[Local][`app.${text}`]) {
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(
        translationMessages[Local][`app.${text}`]
      );
      return hasHtml
        ? htmlParse(translationMessages[Local][`app.${text}`])
        : translationMessages[Local][`app.${text}`];
    } else {
      return text && text.split("_").join(" ");
    }
    // return translationMessages[Local][id] || defaultMessage;
  } else {
    const defaultMessage = defaultText;
    // let trs = translationMessages[Local][id] || defaultMessage;
    let trs = "";
    if (translationMessages[Local][id]) {
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(translationMessages[Local][id]);
      trs = hasHtml
        ? htmlParse(translationMessages[Local][id])
        : translationMessages[Local][id];
    } else if (defaultMessage) {
      trs = defaultMessage;
    } else if (translationMessages[Local][`app.${text}`]) {
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(
        translationMessages[Local][`app.${text}`]
      );
      trs = hasHtml
        ? htmlParse(translationMessages[Local][`app.${text}`])
        : translationMessages[Local][`app.${text}`];
    } else {
      trs = text && text.split("_").join(" ");
    }
    for (let i in values) {
      const val = `{${i}}`;
      if (trs.includes(val)) {
        trs = trs.replace(val, values[i]);
      }
    }
    return trs;
  }
}
